import type { EpochSelectorItem } from "@/components/shared/EpochSelector/types";

export const EPOCH_STATUS_META: Record<NonNullable<EpochSelectorItem["status"]>, { label: string; color: string }> = {
  active: {
    label: "Active",
    color: "text-cede-text-accent",
  },
  completed: {
    label: "Ended",
    color: "text-cede-text-secondary",
  },
  pending: {
    label: "Upcoming",
    color: "text-cede-primary",
  },
  paused: {
    label: "Paused",
    color: "text-cede-warning",
  },
};

export const getEpochDisplayNumber = (epoch?: EpochSelectorItem) => {
  if (!epoch) return undefined;
  return epoch.epochNumber + 1;
};

export const getCustomEpochLabel = (epoch?: EpochSelectorItem) => {
  const label = epoch?.label?.trim();
  if (!label) return undefined;

  const displayNumber = getEpochDisplayNumber(epoch);
  if (!displayNumber) return label;

  const normalize = (value: string) => value.toLowerCase().replace(/[#]/g, "").replace(/\s+/g, " ").trim();
  const normalizedLabel = normalize(label);
  const normalizedDefault = normalize(`Epoch ${displayNumber}`);

  if (normalizedLabel === normalizedDefault) {
    return undefined;
  }

  return label;
};

export const getEpochStatusMeta = (status?: EpochSelectorItem["status"]) => {
  if (!status) return undefined;
  return EPOCH_STATUS_META[status];
};

/**
 * Returns the appropriate pause-related subtitle for an epoch.
 *
 * If the epoch is paused → "This epoch is paused"
 * Otherwise, undefined
 */
export const getEpochPauseMessage = (epoch: EpochSelectorItem): string | undefined => {
  if (epoch.status !== "paused") return undefined;
  return "This epoch is paused";
};
